import GeneralPagesBuilder from './general-pages-builder';

export default GeneralPagesBuilder;